module.exports = [{"id":"b3ba84e1-8979-4974-bfee-ace660ab9dd11","name":"Cyverse Cloud - Marana","code":"CYCM"},{"id":"b3ba84e1-8979-4974-bfee-ace660ab9dd12","name":"iPlant Workshop Cloud - Tucson","code":"IWKT"}]


//////////////////
// WEBPACK FOOTER
// ./src/PROVIDER_DATA.json
// module id = 2055
// module chunks = 0